import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star, Crown, BadgeCheck } from 'lucide-react';
const testimonials = [{
  quote: 'Llevaba 3 meses rogando y en 2 días con la guía recuperé mi paz mental. El audio de emergencia me salvó de escribirle anoche.',
  name: 'Julieta R.',
  province: 'Córdoba, AR',
  initials: 'JR',
  color: 'from-rose-900 to-rose-700'
}, {
  quote: 'Pensé que era imposible dejar de mirar su Instagram. El Protocolo del Búnker Digital fue lo único que me funcionó de verdad.',
  name: 'Micaela G.',
  province: 'Santa Fe, AR',
  initials: 'MG',
  color: 'from-violet-900 to-violet-700'
}, {
  quote: 'El precio es nada comparado con volver a dormir tranquila. Gracias por devolverme el mando de mi vida.',
  name: 'Sofía P.',
  province: 'Buenos Aires, AR',
  initials: 'SP',
  color: 'from-amber-900 to-amber-700'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
function Stars() {
  return <div className="flex gap-1 mb-4" data-id="element-167">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" strokeWidth={0.5} data-id="element-168" />)}
    </div>;
}
export function Testimonials() {
  return <section className="py-32 px-6 relative border-t border-gold/10 overflow-hidden" data-id="element-169">
      {/* Glassmorphism background */}
      <div className="absolute inset-0 bg-charcoal/70 backdrop-blur-xl" data-id="element-170" />
      <div className="absolute inset-0 bg-gradient-to-b from-gold/[0.03] via-transparent to-gold/[0.03]" data-id="element-171" />

      {/* Floating crown watermark */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" data-id="element-172">
        <Crown className="w-64 h-64 text-gold/[0.04]" strokeWidth={0.5} data-id="element-173" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-174">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-175">
          <div className="inline-flex items-center gap-2 bg-gold/10 border border-gold/20 rounded-full px-4 py-1.5 mb-6" data-id="element-176">
            <BadgeCheck className="w-4 h-4 text-gold" strokeWidth={2} data-id="element-177" />
            <span className="font-sans text-xs font-bold text-gold uppercase tracking-widest" data-id="element-178">
              Compras Verificadas
            </span>
          </div>
          <h2 className="font-playfair text-4xl md:text-5xl text-white mb-6" data-id="element-179">
            Resultados Reales de{' '}
            <span className="text-gold italic" data-id="element-180">Soberanía Emocional</span>
          </h2>
          <div className="w-24 h-[1px] bg-gold mx-auto opacity-50" data-id="element-181" />
        </motion.div>

        {/* Testimonial Cards */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-182">
          {testimonials.map((t, index) => <motion.div key={index} variants={itemVariants} className="bg-white/[0.04] backdrop-blur-md p-7 sm:p-8 rounded-md border border-gold/20 flex flex-col justify-between hover:border-gold/40 transition-colors duration-500 relative overflow-hidden group" data-id="element-183">
              {/* Subtle hover glow */}
              <div className="absolute inset-0 bg-gradient-to-b from-gold/[0.03] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-184" />

              <div className="relative z-10" data-id="element-185">
                <Stars data-id="element-186" />
                <p className="font-sans text-gray-300 font-light leading-relaxed italic mb-6 text-[15px]" data-id="element-187">
                  "{t.quote}"
                </p>
              </div>

              {/* Author row */}
              <div className="relative z-10 flex items-center gap-3 pt-4 border-t border-white/5" data-id="element-188">
                {/* Avatar */}
                <div className={`flex-shrink-0 w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-gradient-to-br ${t.color} flex items-center justify-center border border-white/10`} data-id="element-189">
                  <span className="font-sans text-xs sm:text-sm font-bold text-white/90 tracking-wide" data-id="element-190">
                    {t.initials}
                  </span>
                </div>

                {/* Name + Province */}
                <div className="flex flex-col" data-id="element-191">
                  <span className="font-playfair text-white text-base leading-tight" data-id="element-192">
                    {t.name}
                  </span>
                  <span className="font-sans text-xs text-gold/60 tracking-wide mt-0.5" data-id="element-193">
                    {t.province}
                  </span>
                </div>

                {/* Verified badge */}
                <BadgeCheck className="w-4 h-4 text-gold/50 ml-auto flex-shrink-0" strokeWidth={2} data-id="element-194" />
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}